import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import { Button } from '@/shared/ui';

import { NotFoundPage } from './NotFoundPage';

/**
 * Catch-all `errorElement` mounted on the root route. Renders the 404 page
 * for missed routes and a generic "something went wrong" screen for anything
 * else. Real FE errors also fall through here.
 */
export function RootErrorPage() {
  const { t } = useTranslation('shell');
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFoundPage />;
  }

  return (
    <main
      id="main"
      data-page="errors/generic"
      className="mx-auto flex min-h-dvh max-w-lg flex-col items-center justify-center gap-4 overflow-y-auto p-8 text-center"
    >
      <p className="text-xs font-semibold uppercase tracking-wide text-danger-strong">500</p>
      <h1 className="text-2xl font-semibold text-fg">{t('errors.genericTitle')}</h1>
      <p className="text-sm text-fg-muted">{t('errors.genericBody')}</p>
      <Button onClick={() => window.location.reload()}>{t('errors.retry')}</Button>
    </main>
  );
}
